module.exports = __webpack_public_path__ + "img/Jingdong_Wang@2x.697951ce.png";